import React, { useEffect } from "react";
import {
    FaPuzzlePiece,
    FaBolt,
    FaMobileAlt,
    FaRocket,
    FaShieldAlt
} from "react-icons/fa";
import "./ReactNativeFeatures.css";

const ReactNativeFeatures = () => {

    useEffect(() => {

        const items = document.querySelectorAll(".rnf-item");

        items.forEach((item, i) => {

            item.style.opacity = "0";
            item.style.transform =
                i % 2 === 0
                    ? "translateX(-120px)"
                    : "translateX(120px)";

            setTimeout(() => {

                item.style.transition = "1s ease";

                item.style.opacity = "1";

                item.style.transform = "translateX(0)";

            }, i * 250);

        });

    }, []);

    const features = [
        {
            icon: <FaPuzzlePiece />,
            title: "Reusable Components",
            desc: "Create scalable UI using reusable components for faster and cleaner development.",
        },
        {
            icon: <FaBolt />,
            title: "Hot Reload",
            desc: "Instantly preview changes without rebuilding the complete application.",
        },
        {
            icon: <FaMobileAlt />,
            title: "Native UI Experience",
            desc: "Deliver smooth mobile experiences with native-like interactions.",
        },
        {
            icon: <FaRocket />,
            title: "High Performance",
            desc: "Optimized rendering and efficient architecture for faster apps.",
        },
        {
            icon: <FaShieldAlt />,
            title: "Secure Architecture",
            desc: "Advanced security implementation for reliable applications.",
        },
    ];

    return (
        <>
            <section
                style={{
                    position: "relative",
                    background: "#050505",
                    padding: "150px 24px",
                    overflow: "hidden",
                }}
            >

                {/* BACKGROUND */}
                <div className="rnf-grid-bg"></div>

                <div className="rnf-glow rnf-glow1"></div>
                <div className="rnf-glow rnf-glow2"></div>

                <div
                    style={{
                        maxWidth: "1250px",
                        margin: "0 auto",
                        position: "relative",
                        zIndex: 2,
                    }}
                >

                    {/* TOP */}
                    <div className="rnf-top">

                        <div className="rnf-badge">
                            🚀 React Native Features
                        </div>

                        <h2>
                            Powerful Features
                            <br />
                            of <span>React Native</span>
                        </h2>

                        <p>
                            React Native provides modern development tools,
                            native performance and scalable architecture
                            to create next-generation mobile applications.
                        </p>

                    </div>

                    {/* TIMELINE */}
                    <div className="rnf-timeline">

                        <div className="rnf-line"></div>

                        {features.map((item, i) => (

                            <div
                                key={i}
                                className={`rnf-item ${i % 2 === 0
                                    ? "left"
                                    : "right"
                                    }`}
                            >

                                {/* DOT */}
                                <div className="rnf-dot"></div>

                                {/* CARD */}
                                <div
                                    className="rnf-card"
                                    onMouseEnter={(e) => {

                                        e.currentTarget.style.transform =
                                            "scale(1.04)";

                                        e.currentTarget.style.borderColor =
                                            "#E8212A";

                                        e.currentTarget.style.boxShadow =
                                            "0 35px 80px rgba(232,33,42,.18)";

                                    }}
                                    onMouseLeave={(e) => {

                                        e.currentTarget.style.transform =
                                            "scale(1)";

                                        e.currentTarget.style.borderColor =
                                            "rgba(255,255,255,.08)";

                                        e.currentTarget.style.boxShadow =
                                            "none";

                                    }}
                                >

                                    {/* icon */}
                                    <div className="rnf-icon">
                                        {item.icon}
                                    </div>

                                    <h3>{item.title}</h3>

                                    <p>{item.desc}</p>

                                    <div className="rnf-hover"></div>

                                </div>

                            </div>

                        ))}

                    </div>

                </div>
            </section>
        </>
    );
};

export default ReactNativeFeatures;